import { render, staticRenderFns } from "./oeder.vue?vue&type=template&id=7141503b&scoped=true&"
import script from "./oeder.vue?vue&type=script&lang=js&"
export * from "./oeder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7141503b",
  null
  
)

export default component.exports